import { render, staticRenderFns } from "./consumeDialog.vue?vue&type=template&id=892553a4"
import script from "./consumeDialog.vue?vue&type=script&lang=js"
export * from "./consumeDialog.vue?vue&type=script&lang=js"
import style0 from "./consumeDialog.vue?vue&type=style&index=0&id=892553a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports